import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../../../shared/components/table/Table";
import ActiveBadge from "../../../../../../shared/components/badge/ActiveBadge";
import EditNavbarItemsPermissionsDialog from "./edit/EditNavbarItemsPermissionsDialog";

const NavbarItemsPermissionsTable = ({ data, onEditionHandler }) => {
  return (
    <Table>
      <TableHeader>
        <TableHead>Código</TableHead>
        <TableHead>Etiqueta i18n</TableHead>
        <TableHead>Ruta</TableHead>
        <TableHead>Estado</TableHead>
        <TableHead>Permitir acceso</TableHead>
        <TableHead></TableHead>
      </TableHeader>
      <TableBody>
        {data &&
          data.map((row) => (
            <TableRow key={row.code}>
              <TableCell>{row.code}</TableCell>
              <TableCell>{row.label}</TableCell>
              <TableCell>{row.route}</TableCell>
              <TableCell>{row.status}</TableCell>
              <TableCell>
                <ActiveBadge booleanValue={row.hasAccess} />
              </TableCell>
              <TableCell>
                <EditNavbarItemsPermissionsDialog
                  onSubmitHandler={onEditionHandler}
                  navbarItem={row}
                />
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
};

export default NavbarItemsPermissionsTable;
